export default[
    {
        path: 'myApp',
        name: 'MyApp',
        component: () => import(/* webpackChunkName: "appManage" */ '@/views/sale/appManage/index.vue'),
    },
];
